import { makeStyles } from "@material-ui/core";

export default makeStyles(theme => ({
  cActions: {
    padding: theme.spacing(0)
  },
  cAction: {
    marginRight: theme.spacing(1.5),
    color: theme.palette.jamii.darkAccent
  },
  cActionSize: {
    padding: theme.spacing(1, 0),
    fontSize: theme.typography.h5.fontSize
  },

  cFooter: {
    flexDirection: "column",
    padding: theme.spacing(0.5, 1)
  },
  cFooterText: {
    margin: theme.spacing(0.3, 0),
    fontSize: theme.typography.body2.fontSize,
    fontWeight: theme.typography.fontWeightRegular,
    color: theme.palette.primary.main,
    "& strong": {
      padding: theme.spacing(0, 0.5),
      borderBottom: `2px solid ${theme.palette.jamii.orange}`
    }
  },
  cInterest: {
    margin: theme.spacing(0.5, 0),
    fontSize: theme.typography.body2.fontSize,
    fontWeight: theme.typography.fontWeightRegular,
    color: theme.palette.primary.main,
    textTransform: "lowercase",
    cursor: "pointer",
    "& strong": {
      marginRight: theme.spacing(0.75),
      padding: theme.spacing(0.05, 0.5),
      color: theme.palette.text.main,
      background: theme.palette.jamii.orange,
      border: `1px solid ${theme.palette.primary.main}`,
      borderRadius: theme.spacing(0.25),
      boxShadow: theme.customShadows(theme.palette.primary.main)
    }
  },
  cCreatedAt: {
    fontSize: theme.typography.body2.fontSize,
    fontWeight: theme.typography.fontWeightLight,
    color: theme.palette.text.disabled
  }
}));
